/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbLocalDto
 */
export interface FcbLocalDto {
    /**
     * 
     * @type {number}
     * @memberof FcbLocalDto
     */
    idlocal?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbLocalDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbLocalDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbLocalDto
     */
    idcentre?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbLocalDto
     */
    idlieu?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbLocalDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbLocalDto interface.
 */
export function instanceOfFcbLocalDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbLocalDtoFromJSON(json: any): FcbLocalDto {
    return FcbLocalDtoFromJSONTyped(json, false);
}

export function FcbLocalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbLocalDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idlocal': !exists(json, 'idlocal') ? undefined : json['idlocal'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'idcentre': !exists(json, 'idcentre') ? undefined : json['idcentre'],
        'idlieu': !exists(json, 'idlieu') ? undefined : json['idlieu'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbLocalDtoToJSON(value?: FcbLocalDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idlocal': value.idlocal,
        'code': value.code,
        'description': value.description,
        'idcentre': value.idcentre,
        'idlieu': value.idlieu,
        'actif': value.actif,
    };
}

